import { CrudConfig, TableActionType } from '../../../../model/table';
import { AddressGroup } from '../../../../dtos/version.dto';
import { useStores } from '../../../store';
import addressGroupService from '../../../../services/address-group.service';
import { SystemConfiguration } from '../../../../utils/system-configuration';

export const useAddressGroupsCrudConfig = (): CrudConfig<AddressGroup> => {
    const { fwVersionStore } = useStores();

    return {
        createNewText: 'Add Address Group',
        displayInlineActions: !!fwVersionStore.isSelectedVersionEditable,
        disableEditReason: fwVersionStore.getDisableReason,
        newRecord: {
            displayName: '',
            description: '',
            addresses: []
        },
        entityName: 'Address Group',
        saveCb: async (data: any) => {
            await fwVersionStore.genericCrudMethod(addressGroupService.createAddressGroup, [data]);
        },
        updateCb: async (updatedRecord: AddressGroup, originalRecord: AddressGroup) => {
            const { saneDoNoDeleteAddressName } = SystemConfiguration.getInstance();
            if (originalRecord.addresses.includes(saneDoNoDeleteAddressName)) {
                updatedRecord.addresses = [...updatedRecord.addresses, saneDoNoDeleteAddressName];
            }
            await fwVersionStore.genericCrudMethod(addressGroupService.updateAddressGroup, [updatedRecord, originalRecord.displayName]);
        },
        removeCb: async (data) => {
            await fwVersionStore.genericCrudMethod(addressGroupService.deleteAddressGroup, [data.displayName]);
        },
        disable: { [TableActionType.Remove]: (data) => data.isDefault },
        dataChangesHandler: {}
    };
};